import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconCamping = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconCamping",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M80-120v-120q0-13 4-25t12-23l334-450-46-62q-5-7-7-14t-1-15 5-15 11-12q14-10 30-8t26 16l32 43 32-43q10-14 26-16t30 8 16 26-8 30l-46 62 334 450q8 11 12 23t4 25v120q0 17-11 29t-29 11H120q-17 0-28-11t-12-29m249-40h302L480-371z"
  })
}));